import { render, staticRenderFns } from "./copyList.vue?vue&type=template&id=ceec7212&scoped=true&"
import script from "./copyList.vue?vue&type=script&lang=ts&"
export * from "./copyList.vue?vue&type=script&lang=ts&"
import style0 from "./copyList.vue?vue&type=style&index=0&id=ceec7212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceec7212",
  null
  
)

export default component.exports